<template>
  <div class="app-container basedata">
    <el-tabs v-model="active" @tab-click="handleClick" type="border-card">
      <template v-for="(i,key) in tabs">
        <el-tab-pane :key="key" :name="i.ClassName">
          <div slot="label" style="width: 140px;text-align: center;">{{i.ClassName}}</div>
        </el-tab-pane>
      </template>
    </el-tabs>
    <list ref="list" :column-name="active" style="margin-top: 10px;">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
        <el-button type="success" @click="setStart">启用</el-button>
        <el-button type="warning" @click="setStop">屏蔽</el-button>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/gd/basedata/list";
import editDialog from "@/components/gd/basedata/editDialog";

export default {
  name: "basedata",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      active: "德育类荣誉名称",
      tabs: [
        { ClassName: "德育类荣誉名称", ClassId: "1" },
        { ClassName: "德育类奖项名称", ClassId: "2" },
        { ClassName: "所带班级表彰名称", ClassId: "3" },
        { ClassName: "教学1类竞赛奖项名称", ClassId: "4" },
        { ClassName: "教学2类竞赛奖项名称", ClassId: "5" },
        { ClassName: "教学类荣誉所属项目", ClassId: "6" },
        { ClassName: "团体名称", ClassId: "7" },
        { ClassName: "指导教师项目名称", ClassId: "8" },
        { ClassName: "综合性荣誉名称", ClassId: "9" },
        { ClassName: "指导学生项目名称", ClassId: "10" },
        // { ClassName: "培训项目名称", ClassId: "11" },
        { ClassName: "培训活动主题", ClassId: "23" },
        { ClassName: "最高学历", ClassId: "12" },
        { ClassName: "宿舍楼", ClassId: "13" },
        { ClassName: "类型", ClassId: "14" },
        { ClassName: "级别", ClassId: "15" },
        { ClassName: "类别", ClassId: "16" },
        { ClassName: "指导学生类别", ClassId: "17" },
        { ClassName: "等次", ClassId: "18" },
        { ClassName: "本人撰写部分", ClassId: "19" },
        { ClassName: "培训类型", ClassId: "20" },
        { ClassName: "活动级别", ClassId: "21" },
        { ClassName: "考核情况", ClassId: "22" },
      ],
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      var tab = this.tabs.find((x) => x.ClassName == this.active);
      this.$refs.list.getData({ ClassId: tab.ClassId });
    },
    create() {
      var tab = this.tabs.find((x) => x.ClassName == this.active);
      this.$refs.editDialog.openCreate(tab);
    },
    setStart() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        console.log(this.$message);
        this.$message.warning("请选择要启用的数据");
        return;
      }
      let ids = rows.map((item) => item.DataId);
      this.$refs.list.setStart(ids);
    },
    setStop() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要屏蔽的数据");
        return;
      }
      let ids = rows.map((item) => item.DataId);
      this.$refs.list.setStop(ids);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => item.DataId);
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.basedata .el-tabs .el-tabs__nav {
  white-space: normal !important;
}
.basedata .el-tabs .el-tabs__content{
  padding: 0 !important;
}
</style>